// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__1UsTh","tabs":"LayoutWrapperSideNav_tabs__3ntqT","tab":"LayoutWrapperSideNav_tab__cm4MQ"};